<template>
  <div class="col-md-12 col-sm-12 col-lg-12 col-xl-12 baise pt-2" style="border-radius: 12px 12px 12px 12px;">
    <div class="d-flex align-items-center">
      <img @click="fanhui(0)" class="mt-2 mb-2 curpo dcbd mr-2" style="width: calc(25px + 0.4vw);" src="@/img/login/icon_fanhui@2x.png" alt="" />
      <div class="sjbzt" style="font-size: calc(9px + 0.4vw);font-weight: 700;">{{ $t("申请参加活动") }}</div>
    </div>

    <div class="col-md-12 col-sm-12 col-lg-12 col-xl-12 pl-0 pr-0 pt-3 pb-3" style="font-size: calc(7px + 0.4vw);line-height: calc(15px + 0.5vw);">
      <form class="sjbzt">
        <div class="form-group">
          <label style="font-weight: 500;"> <span style="color: red;">*</span>{{ $t("姓名") }}</label>
          <div>
            <input style="background: #F6F4F0;border: none;font-size: calc(7px + 0.4vw);" v-model="form.name" :disabled='isLoading' type="name" class="sjbxzt form-control srk pl-3" :placeholder="$t('输入全名')">
          </div>
        </div>
        <div class="form-group">
          <label style="font-weight: 500;">{{ $t("活动名称") }}</label>
          <div class="pl-0 pr-0 position-relative col-md-12">
            <!-- 触发Dropdown的按钮 -->
            <button class="d-flex ckqbb zhankai col-sm-3 dydpd pt-2 pb-2 pl-0 pr-0" type="button" id="dropdownMenuButton" @click="cllxfun()">
              <div class="d-flex align-items-center justify-content-between col-md-12">
                <div class="sjbxzt" style="font-size: calc(6px + 0.4vw);">{{ form.hdlx }}
                </div>
                <div><img style="width: calc(7px + 0.4vw);" src="@/img/daohangl/icon_xlcd_xljt@2x (1).png" alt="" /></div>
              </div>
            </button>
            <!-- Dropdown内容，使用v-show控制显示 -->
            <!-- <div class="dropdown-menu yuanjiao xlcd position-absolute col-sm-3 text-center" aria-labelledby="dropdownMenuButton" v-show="cllxDropdownOpen" style="border-radius:7px;background: #FFFAF0;">
            </div> -->
          </div>
        </div>
        <div class="form-group">
          <label style="font-weight: 500;"> <span style="color: red;">*</span>{{ $t("参与形式") }}</label>
          <div>
            <div class="d-flex align-items-center mt-2 mb-2">
              <div @click="jkfs(item.id)" class="curpo toms yuanjiao mr-2 pt-1 pb-1" v-for="(item, index) in zflb" :key="index" style="width: calc(70px + 0.5vw);text-align: center;" :style="{ 'background': item.id == form.cyxs ? '#FEF7F6' : '#F6F4F0', 'border': item.id == form.cyxs ? '1px solid #FAB1AB' : 'none' }">
                <div class="toms-p sjbxzt">{{ item.name }}</div>
              </div>
            </div>
            <div class="mt-2 form-text" style="color: red;">{{ smoall }}</div>
          </div>
        </div>
        <div v-if="volunteer_setting.length>0&&form.cyxs==1" class="d-flex align-items-center justify-content-between" style="flex-wrap: wrap;">
          <div style="width: 100%;display:flex;justify-content: space-between;align-items: center;" class="mb-3">
            <div>
              <!-- <span class=" btnFontsizes" style="color: #000">志工服務班次</span> -->
              <label  style="font-weight: 500;margin-bottom:8px">{{ $t("志工服務班次") }}</label>
            </div>
            <div>
              <button class="ckqbb zhankai pt-1 pb-1 pl-2 pr-2 mr-3 btnFontsize" style="background: #ff9f2b;" type="button" @click="trainingClick">
                查看培訓場次
              </button>
              <button class="ckqbb zhankai pt-1 pb-1 pl-2 pr-2 btnFontsize" style="background: #ff9f2b;" type="button" @click="allClick">
                全選
              </button>
            </div>
          </div>
          <div class="asdcas yinc yuanjiao p-3 mb-3"  v-for="(item,index) in volunteer_setting" :key="index" :style="{'border':activity_volunteer_setting_ids.includes(item.id)?'1px solid #FAB1AB':'1px solid #F6F4F0','background':activity_volunteer_setting_ids.includes(item.id)?'#FEF7F6':'#F6F4F0'}">
            <div v-if="item.volunteer_num>item.people_number" @click="voitem(item.id)" style="cursor: pointer;">
              <div class="mb-2" style="display: flex;justify-content: space-between;align-items: center;">
                <div style="font-weight: 500;color: #000;font-size: calc(8px + 0.4vw);">{{ $t("服務") }}</div>
                <div style="color:rgb(200,145,62);font-weight: 500;font-size: calc(7px + 0.4vw);">{{ setting_obj.worker_schedule_time[index] }}<img   v-if="activity_volunteer_setting_ids.includes(item.id)" style="width: 15px;height: 15px;" class="ml-2" src="@/img/icon_baoming_xuanzhong@2x.png" alt=""></div>
                <!-- {{ setting_obj.worker_schedule_time }} -->
              </div>
              <div class="mb-2" style="display: flex;justify-content: left;align-items: center;">
                <!-- <div>{{ $t("志工需求") }}</div> -->
                <div style="width:35%;font-size: calc(8px + 0.4vw);">志工需求人數</div>
                <div style="font-weight: 500;font-size: calc(8px + 0.4vw);">{{ item.volunteer_num }}人</div>
              </div>
              <div class="mb-2" style="display: flex;justify-content: left;align-items: center;">
                <!-- <div>{{ $t("已報名志工") }}</div> -->
                <div style="width:35%;font-size: calc(8px + 0.4vw);">已報名志工人數</div>
                <div style="font-weight: 500;font-size: calc(8px + 0.4vw);">{{ item.people_number }}人</div>
              </div>
              <div class="mb-2" style="display: flex;justify-content: left;align-items: center;">
                <div style="width:35%;font-size: calc(8px + 0.4vw);">{{ $t("工時") }}</div>
                <div style="font-weight: 500;font-size: calc(8px + 0.4vw);">{{ item.man_hour }}h</div>
              </div>
              <div class="mb-2" style="display: flex;justify-content: left;align-items: center;">
                <div style="width:35%;font-size: calc(8px + 0.4vw);">{{ $t("活動地點") }}</div>
                <div style="font-weight: 500;font-size: calc(8px + 0.4vw);">{{ setting_obj.address ? setting_obj.address : '線上活動' }} </div>
              </div>
              <div class="mb-2" style="display: flex;justify-content: right;align-items: center;font-size: calc(8px + 0.4vw);">
                <!-- <div>{{ $t("活動地點") }}</div> -->
                <div @click.stop="clcikDetail(item , index)" >詳情</div>
              </div>
            </div>
            <div v-else style="cursor: no-drop;">
              <div class="mb-2" style="display: flex;justify-content: space-between;align-items: center;">
                <div style="font-weight: 600;color: #000;">{{ $t("志工服務需求") }}</div>
                <div v-if="activity_volunteer_setting_ids.includes(item.id)"><img style="width: 15px;height: 15px;" src="@/img/icon_baoming_xuanzhong@2x.png" alt=""></div>
              </div>
              <div class="mb-2" style="display: flex;justify-content: space-between;align-items: center;">
                <div>{{ $t("服務時間") }}</div>
                <div style="font-weight: 600;">{{ timeFilter(item.service_begin_time) }} ~ {{ timeFilter(item.service_end_time) }} </div>
              </div>
              <div class="mb-2" style="display: flex;justify-content: space-between;align-items: center;">
                <div>{{ $t("志工需求") }}</div>
                <div style="font-weight: 600;">{{ item.volunteer_num }}人</div>
              </div>
              <div class="mb-2" style="display: flex;justify-content: space-between;align-items: center;">
                <div>{{ $t("已報名志工") }}</div>
                <div style="font-weight: 600;">{{ item.people_number }}人</div>
              </div>
              <div style="display: flex;justify-content: space-between;align-items: center;">
                <div>{{ $t("工時") }}</div>
                <div style="font-weight: 600;">{{ item.volunteer_hour }}h</div>
              </div>
            </div>
          </div>
          <div class="asdcass aaaaa yuanjiao p-3 mb-3" @click="voitem(item.id)" :style="{'border':activity_volunteer_setting_ids.includes(item.id)?'1px solid #FAB1AB':'1px solid #F6F4F0','background':activity_volunteer_setting_ids.includes(item.id)?'#FEF7F6':'#F6F4F0'}" v-for="(item,index) in volunteer_setting" :key="index">
            <div class="mb-2" style="display: flex;justify-content: space-between;align-items: center;">
              <div style="font-weight: 500;color: #000;font-size: calc(13px + 0.4vw);">{{ $t("服務") }}</div>
              <div style="color:rgb(200,145,62);font-weight: 500;font-size: calc(13px + 0.4vw);">{{ setting_obj.worker_schedule_time[index] }}<img v-if="activity_volunteer_setting_ids.includes(item.id)" style="width: 15px;height: 15px;" class="ml-2" src="@/img/icon_baoming_xuanzhong@2x.png" alt=""></div>
              
            </div>
            <div class="mb-2" style="display: flex;justify-content: left;align-items: center;">
              <!-- <div>{{ $t("志工需求") }}</div> -->
              <div style="width:35%;font-size: calc(13px + 0.4vw);">志工需求人數</div>
              <div style="font-weight: 500;font-size: calc(13px + 0.4vw);">{{ item.volunteer_num }}人</div>
            </div>
            <div class="mb-2" style="display: flex;justify-content: left;align-items: center;">
              <!-- <div>{{ $t("已報名志工") }}</div> -->
              <div style="width:35%;font-size: calc(13px + 0.4vw);">已報名志工人數</div>
              <div style="font-weight: 500;font-size: calc(13px + 0.4vw);">{{ item.people_number }}人</div>
            </div>
            <div style="display: flex;justify-content: left;align-items: center;">
              <div style="width:35%;font-size: calc(13px + 0.4vw);">{{ $t("工時") }}</div>
              <div style="font-weight: 500;font-size: calc(13px + 0.4vw);">{{ item.man_hour }}h</div>
            </div>
            <div class="mb-2" style="display: flex;justify-content: left;align-items: center;">
              <div style="width:35%;font-size: calc(13px + 0.4vw);">{{ $t("活動地點") }}</div>
              <div style="font-weight: 500;font-size: calc(13px + 0.4vw);">{{ setting_obj.address ? setting_obj.address : '線上活動' }} </div>
            </div>
            <div class="mb-2" style="display: flex;justify-content: right;align-items: center;font-size: calc(13px + 0.4vw);">
              <!-- <div>{{ $t("活動地點") }}</div> -->
              <div @click="clcikDetail(item , index)">詳情</div>
            </div>
          </div>
        </div>
        <div v-if="form.cyxs==1 && is_insure==2">
          <div class="form-group">
            <label style="font-weight: 500;"><span style="color: red;">*</span>{{ $t("身份证号") }}</label>
            <div>
              <input style="background: #F6F4F0;border: none;font-size: calc(7px + 0.4vw);" v-model="form.id_number" :disabled='isLoading' type="name" class="sjbxzt form-control srk pl-3" :placeholder="$t('请输入身份ID')">
            </div>
          </div>
          <div class="col-sm-12 d-flex mb-3 pl-0 pr-0 justify-content-between align-item-center">
            <div class=" pl-0 pr-0 col-sm-4 ">
              <div class=" col-sm-12 pl-0 pr-0">
                <label style="font-weight: 500;"><span style="color: red;">*</span>{{ $t('生日') }}</label>
                <div class="pl-0 pr-0 position-relative col-md-12 pl-0">
                  <!-- 触发Dropdown的按钮 -->
                  <button class="d-flex ckqbb zhankai col-sm-12 dydpd pt-2 pb-2 pl-0 pr-0" type="button" id="dropdownMenuButton" @click="niantoggleDropdown()">
                    <div class="d-flex align-items-center justify-content-between col-md-12 pl-0 pr-0 sjbxxzt" style="font-size: calc(8px + 0.4vw);padding-left: calc(10px + 0.4vw) !important;padding-right: calc(10px + 0.4vw) !important">
                      <div>{{ selectedYear ? selectedYear :  $t('請選擇') }}
                      </div>
                      <div>
                        {{ $t('年') }}
                        <img class="ml-1" style="width: calc(7px + 0.4vw);" src="@/img/daohangl/icon_xlcd_xljt@2x (1).png" alt="" />
                      </div>
                    </div>
                  </button>
                  <div class="dropdown-menu yuanjiao xlcd position-absolute col-sm-12 text-center" aria-labelledby="dropdownMenuButton" v-show="nianisDropdownOpen" style="border-radius:7px;background: #FFFAF0;height: 250px;overflow-y: auto;">
                    <div class="dropdown-item xuazz yuanjiao mb-2 sjbxzt curpo" v-for="(year, index) in years" :key="index" :style="{ 'background': year == selectedYear ? '#FFD672' : '' }" @click="nianxuanz(year)" href="#">{{ year }}</div>
                  </div>
                </div>
              </div>
            </div>

            <div class=" pl-0 pr-0 col-sm-4 pl-2">
              <div class=" col-sm-12 pl-0 pr-0 mt-2">
                <label style="font-weight: 500;"></label>
                <div class="pl-0 pr-0 position-relative col-md-12 pl-0 pr-0">
                  <!-- 触发Dropdown的按钮 -->
                  <button class="d-flex ckqbb zhankai col-sm-12 dydpd pt-2 pb-2 pl-0 pr-0" type="button" id="dropdownMenuButton" @click="youtoggleDropdown()">
                    <div class="d-flex align-items-center justify-content-between col-md-12 pl-0 pr-0 sjbxxzt" style="font-size: calc(8px + 0.4vw);padding-left: calc(10px + 0.4vw) !important;padding-right: calc(10px + 0.4vw) !important">
                      <div>{{ selectedMonth ? selectedMonth : $t('請選擇') }}
                      </div>
                      <div>
                        {{ $t('月') }}
                        <img class="ml-1" style="width: calc(7px + 0.4vw);" src="@/img/daohangl/icon_xlcd_xljt@2x (1).png" alt="" />
                      </div>
                    </div>
                  </button>
                  <!-- Dropdown内容，使用v-show控制显示 -->
                  <div class="dropdown-menu yuanjiao xlcd position-absolute col-sm-12 text-center" aria-labelledby="dropdownMenuButton" v-show="youisDropdownOpen" style="border-radius:7px;background: #FFFAF0;height: 250px;overflow-y: auto;">
                    <div class="dropdown-item xuazz yuanjiao mb-2 sjbxzt curpo" v-for="(month, index) in months" :key="index" :style="{ 'background': month == selectedMonth ? '#FFD672' : '' }" @click="youxuanz(month)" href="#">{{ month }}</div>
                  </div>
                </div>
              </div>
            </div>
            <div class=" pl-0 pr-0 col-sm-4">
              <div class=" col-sm-12 pl-0 pr-0 mt-2">
                <label style="font-weight: 500;"></label>
                <div class="pl-0 pr-0 position-relative col-md-12 pl-2 pr-0">
                  <!-- 触发Dropdown的按钮 -->
                  <button class="d-flex ckqbb zhankai col-sm-12 dydpd pt-2 pb-2 pl-0 pr-0" type="button" id="dropdownMenuButton" @click="tiantoggleDropdown()">
                    <div class="d-flex align-items-center justify-content-between col-md-12 pl-0 pr-0 sjbxxzt" style="font-size: calc(8px + 0.4vw);padding-left: calc(10px + 0.4vw) !important;padding-right: calc(10px + 0.4vw) !important">
                      <div>{{ selectedDay ? selectedDay : $t('請選擇') }}
                      </div>
                      <div>
                        {{ $t('日') }}
                        <img class="ml-1" style="width: calc(7px + 0.4vw);" src="@/img/daohangl/icon_xlcd_xljt@2x (1).png" alt="" />
                      </div>
                    </div>
                  </button>
                  <div class="dropdown-menu yuanjiao xlcd position-absolute col-sm-12 text-center" aria-labelledby="dropdownMenuButton" v-show="tianisDropdownOpen" style="border-radius:7px;background: #FFFAF0;height: 250px;overflow-y: auto;">
                    <div class="dropdown-item xuazz yuanjiao mb-2 sjbxzt curpo" v-for="(item, index) in days" :key="index" :style="{ 'background': item == selectedDay ? '#FFD672' : '' }" @click="tianxuanz(item)" href="#">{{ item }}</div>
                  </div>
                </div>
              </div>
            </div>

          </div>
          <div style="color: #ff797a;margin-bottom: 10px;    margin-top: -10px;">溫馨提示：活動主辦單位將為志工購買保險，請如實填寫資料</div>
        </div>
        <!-- 邮箱 -->
        <div class="form-group">
          <label style="font-weight: 500;">{{ $t('login.emailLoginButton') }}</label>
          <div>
            <input style="background: #F6F4F0;border: none;font-size: calc(7px + 0.4vw);" v-model="form.emil" :disabled='isLoading' @input="validatePhone()" type="text" class="form-control sjbxzt srk" :placeholder="$t('login.qsryx')">
            <small class="form-text" style="color: red;" v-if="emilError">{{ emilError }}</small>
          </div>
        </div>
        <!-- 验证码 -->
        <div class="form-group">
          <label style="font-weight: 500;">{{ $t('login.captchaLabel') }}</label>
          <div>
            <b-form-input @input="emyzmsd" style="background: #F6F4F0;border: none;font-size: calc(7px + 0.4vw);" v-model="form.use" :disabled='isLoading' type="number" class="form-control sjbxzt srk mb-3" :placeholder="$t('login.captchaPlaceholder')">
            </b-form-input>
            <div class="position-absolute yzm curpo pb-1" v-if="emyzmqr==1">
              <div v-show="timeTrue" @click="obtainCode()">
                {{ $t('login.getCaptchaButton') }}
              </div>
              <div v-show="!timeTrue">
                {{ time }}{{ $t('login.resend_countdown') }}
              </div>
            </div>
            <div v-else class="position-absolute yzm pb-1" style="background: #FAB1AB;">
              {{ $t("验证码正确") }}
            </div>
          </div>
        </div>

        <div class="form-group d-flex align-items-center" style="margin-top: 60px;">
          <img v-if="agreement" @click="agreement = !agreement" class="curpo mr-2" style="width: calc(10px + 0.4vw);" src="@/img/login/icon_dl_xy_xz@2x.png" alt="" />
          <img v-else @click="agreement = !agreement" class="curpo mr-2" style="width: calc(10px + 0.4vw);" src="@/img/login/icon_dl_xy_wxz@2x.png" alt="" />
          <span @click="agreement = !agreement" class="curpo sjbxzt" style="font-size: calc(7px + 0.4vw);">{{
						$t("勾选即表示您同意平台用户协议与隐私政策") }}</span>
        </div>
        <div @click="bulletframe()" class="pl-4 pr-4 pt-2 pb-2 yuanjiao ckqbb curpo mt-3 sjbzt" style="font-size: calc(6px + 0.4vw);background: #FFD672;width: calc(120px + 0.5vw);text-align: center;">
          {{ $t("参与活动") }}
          <span v-if="isLoading" class="spinner-border spinner-border-sm ml-2" role="status" aria-hidden="true">
          </span>
        </div>
        <!-- <div @click="bulletframe()" class="pl-4 pr-4 pt-2 pb-2 yuanjiao ckqbb curpo mt-4"
					style="font-size: calc(6px + 0.4vw);background: #E5E5E5;width: calc(120px + 0.5vw);text-align: center;">
					{{ $t("已提交，请耐心等待") }}
					<span v-if="isLoading" class="spinner-border spinner-border-sm ml-2" role="status"
						aria-hidden="true">
					</span>
				</div> -->
      </form>
    </div>
    <b-modal v-model="workersModalShow" modal-class="custom-modal-width" title="志工服務班次" :centered='true' hide-footer>
      <div class="modalClass">
        <div class="mb-2" style="display: flex;justify-content: left;align-items: center;">
          <!-- <div>{{ $t("志工需求") }}</div> -->
          <div style="width:35%;font-size: calc(8px + 0.4vw);" class="modalClassFont">服務日期</div>
          <div style="font-weight: 500;font-size: calc(8px + 0.4vw);">{{ workerDetails.worker_schedule_time }}</div>
        </div>
        <div class="mb-2" style="display: flex;justify-content: left;align-items: center;">
          <div style="width:35%;font-size: calc(8px + 0.4vw);" class="modalClassFont">服務時間</div>
          <div style="font-weight: 500;font-size: calc(8px + 0.4vw);">
            <div style="width:100%" v-for="(val,ind) in workerDetails.service_time" :key="ind">
              {{ val }}
            </div>
          </div>
        </div>
        <div class="mb-2" style="display: flex;justify-content: left;align-items: center;">
          <div style="width:35%;font-size: calc(8px + 0.4vw);" class="modalClassFont">志工需求人數</div>
          <div style="font-weight: 500;font-size: calc(8px + 0.4vw);">{{ workerDetails.volunteer_num }}人</div>
        </div>
        <div class="mb-2" style="display: flex;justify-content: left;align-items: center;">
          <div style="width:35%;font-size: calc(8px + 0.4vw);" class="modalClassFont">已報名志工人數</div>
          <div style="font-weight: 500;font-size: calc(8px + 0.4vw);">{{ workerDetails.people_number }}人</div>
        </div>
        <div class="mb-2" style="display: flex;justify-content: left;align-items: center;">
          <div style="width:35%;font-size: calc(8px + 0.4vw);" class="modalClassFont">工時</div>
          <div style="font-weight: 500;font-size: calc(8px + 0.4vw);">{{ workerDetails.man_hour }}h</div>
        </div>
        <div class="mb-2" style="display: flex;justify-content: left;align-items: center;">
          <div style="width:35%;font-size: calc(8px + 0.4vw);" class="modalClassFont">活動地點</div>
          <div style="font-weight: 500;font-size: calc(8px + 0.4vw);">{{ workerDetails.address }}</div>
        </div>
        <div class="mb-2" style="display: flex;justify-content: left;align-items: center;">
          <div style="width:35%;font-size: calc(8px + 0.4vw);" class="modalClassFont">負責人</div>
          <div style="font-weight: 500;font-size: calc(8px + 0.4vw);">{{ workerDetails.name_of_organizer }}</div>
        </div>
        <div class="mb-2" style="display: flex;justify-content: left;align-items: center;">
          <div style="width:35%;font-size: calc(8px + 0.4vw);" class="modalClassFont">聯繫電話</div>
          <div style="font-weight: 500;font-size: calc(8px + 0.4vw);">{{ workerDetails.phone_of_organizer }}</div>
        </div>
      </div>  
    </b-modal>
    <b-modal v-model="training_modalShow" modal-class="custom-modal-width" title="志工培訓班次" :centered='true' hide-footer>
      <div class="modalClass">
          <Timeline :timelineDesc="setting_obj.training_setting" :width="480" :type="volunteer_type" class="mt-4"/>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { activity_apply, apply_base , activity_information } from "@/request/hshd/index.js";
import { sendcodeemil, check_email } from "@/request/api.js";
import { formatTimestampsm } from "@/utils/common.js";
import Timeline from '@/components/Timeline/timeline.vue'
export default {
  components: {
    Timeline
  },
  data() {
    return {
      activity_volunteer_setting_ids: [],
      activity_training_setting_ids: [],
      volunteer_setting: [],
      training_setting: [],
      emyzmqr: 1,
      need_volunteer: "",
      id: "",
      isLoading: false,
      agreement: false,
      emilError: "",
      smoall: "",
      volunteer_type:'1',
      cllxDropdownOpen: false,
      training_modalShow:false,
      time: "",
      timeTrue: true, //判断验证码
      setting_obj:{},
      workerDetails:{},
      zflb: [
        {
          id: 0,
          name: this.$t("普通用户"),
        },
        {
          id: 1,
          name: this.$t("志工"),
        },
      ],
      form: {
        name: "",
        emil: "",
        use: "",
        cyxs: "0",
        hdlx: "",
        id_number: "",
      },
      selectedYear: '',
      selectedMonth: '', // 月份从1开始
      selectedDay: '',
      years: Array.from(
        {
          length: new Date().getFullYear() - 1900 + 1,
        },
        (_, i) => new Date().getFullYear() - i
      ),
      months: [],
      days: [],
      is_insure: "",
      tianisDropdownOpen: false,
      youisDropdownOpen: false,
      nianisDropdownOpen: false,
      workersModalShow:false,
    };
  },
  created() {},
  mounted() {
    document.documentElement.scrollTop = 0;
    this.updateMonthsAndDays();
  },
  computed: {
    // 根据年份动态计算月份
    monthsComputed() {
      return Array.from(
        {
          length: 12,
        },
        (_, i) => i + 1
      );
    },
    // 根据年份和月份动态计算天数
    daysComputed() {
      const year = this.selectedYear;
      const month = this.selectedMonth;
      let daysInMonth = new Date(year, month, 0).getDate(); // 获取该月有多少天
      return Array.from(
        {
          length: daysInMonth,
        },
        (_, i) => i + 1
      );
    },
  },
  methods: {
    trainingClick(){
      this.training_modalShow = true
    },
    timeFilter(stringTime) {
      return formatTimestampsm(stringTime * 1000);
    },
    voitem(e) {
      var flag = this.activity_volunteer_setting_ids.find((cur) => cur == e);
      if (!flag) {
        this.activity_volunteer_setting_ids.push(e);
      } else {
        this.activity_volunteer_setting_ids =
          this.activity_volunteer_setting_ids.filter((ele) => ele != flag);
      }
    },
    doitem(e) {
      var flag = this.activity_training_setting_ids.find((cur) => cur == e);
      if (!flag) {
        this.activity_training_setting_ids.push(e);
      } else {
        this.activity_training_setting_ids =
          this.activity_training_setting_ids.filter((ele) => ele != flag);
      }
    },
    tianxuanz(e) {
      this.selectedDay = e;
      this.tianisDropdownOpen = false;
    },
    tiantoggleDropdown() {
      this.tianisDropdownOpen = !this.tianisDropdownOpen;
      this.nianisDropdownOpen = false;
      this.youisDropdownOpen = false;
      // 如果需要，可以在这里添加Bootstrap Dropdown的额外处理逻辑
    },
    niantoggleDropdown() {
      this.nianisDropdownOpen = !this.nianisDropdownOpen;
      this.youisDropdownOpen = false;
      this.tianisDropdownOpen = false;
      // 如果需要，可以在这里添加Bootstrap Dropdown的额外处理逻辑
    },
    async updateMonthsAndDays() {
      this.months = this.monthsComputed;
      this.days = this.daysComputed;
    },
    youxuanz(e) {
      this.selectedMonth = e;
      this.updateMonthsAndDays();
      this.youisDropdownOpen = false;
    },
    youtoggleDropdown() {
      this.youisDropdownOpen = !this.youisDropdownOpen;
      this.tianisDropdownOpen = false;
      this.nianisDropdownOpen = false;
      // 如果需要，可以在这里添加Bootstrap Dropdown的额外处理逻辑
    },
    nianxuanz(e) {
      this.selectedYear = e;
      this.updateMonthsAndDays();
      this.nianisDropdownOpen = false;
    },
    async emyzmsd(e) {
      this.emyzmqr = 1;
      let numberArray = e.split("").map((char) => parseInt(char));
      console.log(numberArray.length);
      if (numberArray.length >= "6") {
        console.log(e.slice(0, 6));
        setTimeout(() => {
          this.form.use = e.slice(0, 6);
          check_email({ email: this.form.emil, code: this.form.use }).then(
            (res) => {
              if (res.code == 200) {
                this.$bvToast.toast(this.$t("验证码正确"), {
                  title: this.$t("login.notice"),
                  autoHideDelay: 2000,
                  delay: 5000,
                  appendToast: true,
                  variant: "success",
                });
                this.emyzmqr = 0;
              } else {
                this.$bvToast.toast(this.$t("验证码错误"), {
                  title: this.$t("login.warning"),
                  variant: "danger",
                  autoHideDelay: 5000,
                });
                this.form.use = "";
                this.emyzmqr = 1;
                this.timeTrue = true;
              }
            }
          );
        }, 100);
      }
    },
    async apply_base() {
      const { data } = await apply_base({
        id: this.id,
      });
      this.need_volunteer = data.need_volunteer;
      if (data.need_volunteer == 0) {
        this.zflb.splice(1, 1);
      }
    },
    // 点击详情
    clcikDetail(item , index){
      this.workersModalShow = true
      let timer = ''
      let obj = {
        // worker_schedule_time: '',
        // address:'',
        // name_of_organizer:'',
        // phone_of_organizer:'',
      }
      if(this.setting_obj.participation_pattern == 2 && this.setting_obj.servicing_time == 2){ // 全程固定
        timer = [`${"每天 " + item.service_time[0] + " - " + item.service_time[1]}`]
      }else if(this.setting_obj.participation_pattern == 2 && this.setting_obj.servicing_time == 1){ // 全程弹性
        timer = item.service_time.map((value,nums) => {
          return value.date + " " + value.time[0] + " - " + value.time[1]
        })
        obj.worker_schedule_time = this.setting_obj.worker_schedule_time[0]
        obj.address = this.setting_obj.address
      }else if(this.setting_obj.participation_pattern == 1){ // 弹性
        timer = [`${item.service_time.time[0] + " - " + item.service_time.time[1]}`]
      }
      this.workerDetails = {
        worker_schedule_time: obj.worker_schedule_time ? obj.worker_schedule_time : this.setting_obj.worker_schedule_time[index],
        service_time :  timer,
        volunteer_num: item.volunteer_num,
        people_number: item.people_number,
        man_hour : item.man_hour,
        address : this.setting_obj.address || '無',
        name_of_organizer : this.setting_obj.name_of_organizer,
        phone_of_organizer : this.setting_obj.phone_of_organizer,
      }
    },
    // 时间处理方法
    generateDateRange(dateArray) {
      const startDate = new Date(dateArray[0]);
      const endDate = new Date(dateArray[1]);
      const dateRange = [];
      const currentDate = new Date(startDate);

      while (currentDate <= endDate) {
        const year = currentDate.getFullYear();
        const month = String(currentDate.getMonth() + 1).padStart(2, '0');
        const day = String(currentDate.getDate()).padStart(2, '0');
        const formattedDate = `${year}-${month}-${day}`;
        dateRange.push(formattedDate);
        currentDate.setDate(currentDate.getDate() + 1);
      }

      return dateRange;
    },
    msg(e, v, m,type) {
      // type为666 是企业志工活动那个跳转进入 空则是其他
      console.log(e, v, m, "9999999999",m.volunteer_num , m.volunteer_member_num);
      if (m.volunteer_num <= m.volunteer_member_num && type !=666) {
        this.zflb.splice(1, 1);
        this.smoall = this.$t("當前志工人數已滿，無法報名志工，感謝您的支持");
      }
       if(type == 666){
        this.zflb.splice(0, 1);
        this.form.cyxs = '1';
        if(m.volunteer_num <= m.volunteer_member_num){
          this.smoall = this.$t("當前志工人數已滿，無法報名，感謝您的支持");
        }
      }
      this.id = e;
      this.form.hdlx = v;
      this.is_insure = m.is_insure || '';
      this.volunteer_setting = m.volunteer_setting || [];
      this.setting_obj.work_time = m
      if(m.participation_pattern){
        if((m.participation_pattern == 2 && m.servicing_time == 2) || (m.participation_pattern == 2 && m.servicing_time == 1)){ // 全程参与固定时间
          console.log(m.worker_schedule_time , 'zheshishijian')
          this.setting_obj = {
            worker_schedule_time :[ m.worker_schedule_time[0].split("/") + ' 至 ' + m.worker_schedule_time[1].split("/")],
          }
          console.log(this.setting_obj.worker_schedule_time , 'zheshishijian')
        }else if(m.participation_pattern == 1){
          this.setting_obj = {
            worker_schedule_time : this.generateDateRange(m.worker_schedule_time),
          }
      }
      }
      
      // console.log(m , "这是m")
      this.setting_obj.address = m.address || ''
      this.setting_obj.participation_pattern = m.participation_pattern || ''
      this.setting_obj.servicing_time = m.servicing_time || ''
      this.setting_obj.name_of_organizer = m.name_of_organizer || ''
      this.setting_obj.phone_of_organizer = m.phone_of_organizer || ''
      this.setting_obj.training_setting = m.training_setting || []
      this.setting_obj.training_instructions = m.training_instructions || []

      this.apply_base();
    },
    // 全选
    allClick(){
      if(this.activity_volunteer_setting_ids.length< this.volunteer_setting.length){
        this.activity_volunteer_setting_ids = this.volunteer_setting.map((item) => {
          return item.id
        })
      }else{
        this.activity_volunteer_setting_ids = []
      }
    },
    // 选择活动名称
    cllxxuanz(e) {
      this.form.hdlx = e;
      this.cllxDropdownOpen = false;
    },
    // 活动名称
    cllxfun() {
      this.cllxDropdownOpen = !this.cllxDropdownOpen;
      // 如果需要，可以在这里添加Bootstrap Dropdown的额外处理逻辑
    },
    // 参与形式
    jkfs(e) {
      this.form.cyxs = e;
    },
    fanhui(e) {
      this.$emit("custom", e);
    },
    // 点击
    async bulletframe() {
      if (!this.agreement) {
        this.$bvToast.toast(this.$t("请勾选协议！"), {
          title: this.$t("login.warning"),
          variant: "danger",
          autoHideDelay: 5000,
        });
        return;
      } else if (this.form.name == "") {
        this.$bvToast.toast(this.$t("请输入姓名"), {
          title: this.$t("login.warning"),
          variant: "danger",
          autoHideDelay: 5000,
        });
        return;
      } else if (this.form.hdlx == "") {
        this.$bvToast.toast(this.$t("请选择活动名称"), {
          title: this.$t("login.warning"),
          variant: "danger",
          autoHideDelay: 5000,
        });
        return;
      } else if (this.form.emil == "") {
        this.$bvToast.toast(this.$t("请输入信箱"), {
          title: this.$t("login.warning"),
          variant: "danger",
          autoHideDelay: 5000,
        });
        return;
      } else if (this.form.use == "") {
        this.$bvToast.toast(this.$t("请输入验证码"), {
          title: this.$t("login.warning"),
          variant: "danger",
          autoHideDelay: 5000,
        });
        return;
      } else if (
        this.form.cyxs == 1 &&
        this.activity_volunteer_setting_ids.length == 0
      ) {
        this.$bvToast.toast(this.$t("請選擇志工服務需求"), {
          title: this.$t("login.warning"),
          variant: "danger",
          autoHideDelay: 5000,
        });
        return;
      } else if (
        this.form.cyxs == 1 &&
        !this.form.id_number &&
        this.is_insure == 2
      ) {
        this.$bvToast.toast(this.$t("请输入身份ID"), {
          title: this.$t("login.warning"),
          variant: "danger",
          autoHideDelay: 5000,
        });
        return;
      }
      // this.isLoading = true;
      let birthday =
        this.selectedYear + "-" + this.selectedMonth + "-" + this.selectedDay;
      const { data, code, msg } = await activity_apply({
        id: this.id,
        activity_volunteer_setting_ids: this.activity_volunteer_setting_ids,
        name: this.form.name,
        is_volunteer: this.form.cyxs,
        email: this.form.emil,
        email_code: this.form.use,
        id_number: this.form.id_number,
        birthday: birthday,
      });
      if (code == 200) {
        // this.isLoading = false; // 处理完成后关闭转圈
        this.$bvToast.toast(this.$t("参与成功"), {
          title: this.$t("login.notice"),
          autoHideDelay: 2000,
          delay: 5000,
          appendToast: true,
          variant: "success",
        });
        this.$emit("hdfh", this.id);
        this.fanhui(0)
        // this.$emit("hdfh", this.id);
      } else {
        this.$bvToast.toast(msg, {
          title: this.$t("login.warning"),
          variant: "danger",
          autoHideDelay: 5000,
        });
        this.isLoading = false;
      }
    },
    // 校验验证码
    validatePhone() {
      this.form.use = "";
      this.emyzmqr = 1;
      this.timeTrue = true;
      const regex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
      if (!regex.test(this.form.emil)) {
        this.emilError = this.$t("login.invalid_emil_number");
      } else {
        this.emilError = "";
      }
      if (this.form.emil == "") {
        this.emilError = "";
      }
    },
    // 获取验证码
    async obtainCode() {
      if (this.emilError != "") {
        return;
      } else if (this.form.emil == "") {
        this.$bvToast.toast(this.$t("login.qsryx"), {
          title: this.$t("login.warning"),
          variant: "danger",
          autoHideDelay: 5000,
        });
        return;
      }
      this.$bvToast.toast(this.$t("login.verification_success"), {
        title: this.$t("login.notice"),
        autoHideDelay: 2000,
        delay: 5000,
        appendToast: true,
        variant: "success",
      });
      this.acquire();
      const { code, msg } = await sendcodeemil({
        email: this.form.emil,
      });
      if (code == 200) {
      } else {
        this.$bvToast.toast(msg, {
          title: this.$t("login.warning"),
          variant: "danger",
          autoHideDelay: 5000,
        });
      }
    },
    // 验证码获取成功
    acquire() {
      this.timeTrue = false;
      this.time = 60;
      var setTimeoutS = setInterval(() => {
        this.time--;
        if (this.time <= 0) {
          clearInterval(setTimeoutS);
          this.timeTrue = true;
        }
      }, 1000);
    },
  },
};
</script>

<style scoped>
@media screen and (max-width: 999px) {
  .sjbzt {
    font-size: calc(14px + 0.4vw) !important;
  }
  .sjbxzt {
    font-size: calc(11px + 0.4vw) !important;
  }
  .yinc {
    display: none !important;
  }
  .aaaaa {
    display: block !important;
  }
  .btnFontsize{
    font-size: calc(10px + 0.4vw)!important;
  }
  .btnFontsizes{
    font-size: calc(14px + 0.4vw)!important;
  }
}
.btnFontsize{
  font-size: calc(10px + 0.4vw);
}
.btnFontsizes{
  font-size: calc(10px + 0.4vw);
}
.aaaaa {
  display: none;
}
.dcbd:hover {
  transform: scale(1.2);
}

.ckqbb:hover {
  transform: scale(1.001);
  /* 悬浮时放大1.1倍 */
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
}

.xlcd {
  display: block;
  background: #ffebd2;
  border: none;
}

.xuazz:hover {
  background: #ffebd2;
}

.xlcd::-webkit-scrollbar {
  display: none;
}

.asdcas {
  position: relative;
  font-size: calc(10px + 0.4vw);
  width: 49.4%;
  
  color: #666666;
}

.asdcass {
  position: relative;
  font-size: calc(10px + 0.4vw);
  width: 100%;
  cursor: pointer;
  color: #666666;
}

.zhankai {
  background: #ffd672;
  text-align: center;
  border-radius: 12px 12px 12px 12px;
  border: none;
  font-weight: 400;
  font-size: calc(6px + 0.4vw);
  color: #1a1a1a;
}

.dropdown-menu {
  min-width: calc(25px + 0.5vw) !important;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
}

textarea.form-control {
  overflow-y: auto !important;
}

.yzm {
  height: 27px;
  line-height: 27px;
  text-align: center;
  font-weight: 400;
  font-size: 12px;
  color: #1a1a1a;
  background: #ffd672;
  border-radius: 12px;
  padding: 0 12px;
}
.dropdown-item{
  text-align: left;
}
.modalClass{
  width: 100%;
  background: rgb(246,244,244);
  border-radius: 10px;
  padding: 20px 10px;
}
.modalClassFont{
  color:rgb(102,102,102)
}
</style>